/*
 *   File : active-sip.js
 *   Author : https://evoqins.com
 *   Description : Active SIP card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

//styles
import styles from "../../Style/Component/card.module.scss";

//custom component
import { PrimaryButton, SecondaryButton } from '../Buttons';

const ActiveSIPCard = (props) => {

    let data = props.data;

    const _formatAmount = (amount, toFixed) => {
        if (amount >= 10000000) {
            return (amount / 10000000).toFixed(toFixed ?? 0) + 'Cr'; // Crore
        } else if (amount >= 100000) {
            return (amount / 100000).toFixed(toFixed ?? 0) + 'Lakh'; // Lakh
        } else if (amount >= 1000) {
            return (amount / 1000).toFixed(toFixed ?? 0) + 'K'; // Thousand (K)
        } else {
            return amount ? amount.toString() : ""; // If less than 1000, return the number itself
        }
    }

    return (
        <>
            {
                props.isCardView ?
                    <div className={`${styles.e_sip_card_wrapper} ${props.selectedSIP?.sip_id === data.sip_id ? "e-border-1px-egyptian-blue" : "border-transparent"} ${props.type === 2 ? "pe-none" : ""} transition cursor-pointer e-bg-cultured e-border-radius-16  h-100 p-3`}
                        onClick={props.onClickCard}>
                        {/* fund name */}
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center gap-3 pe-lg-2">
                                <img className="w-40px width-24px-res h-100 object-fit-contain me-1 e-border-radius-10 align-self-stretch e-bg-white p-1"
                                    src={data.icon}
                                    alt="holdings logo" />
                                <h2 className="e-ellipse e-text-onyx e-primary-font-inter e-font-12-res e-font-14-res-lg e-font-16 e-font-weight-400 line-height-20px mb-0">
                                    {data.name}
                                </h2>
                            </div>
                        </div>

                        {/* Type of holding */}
                        {
                            data.type &&
                            <span className="e-text-html-css-gray e-primary-font-inter e-font-10-res e-font-12 e-font-weight-500 line-height-20px px-sm-2 px-1 e-border-radius-18 e-bg-white-marble">
                                {data.type}
                            </span>
                        }

                        {/* Holdings details */}
                        <div className="d-flex justify-content-between my-3">
                            <div className="col-auto d-flex flex-column">
                                <span className="e-text-dark-heather e-primary-font-inter e-font-14-res e-font-14-res-lg  e-font-16 e-font-weight-400 line-height-22px">
                                    Created on
                                </span>
                                <span className="e-text-charleston-green e-primary-font-inter e-font-14-res e-font-14-res-lg e-font-16 e-font-weight-600 line-height-22px">
                                    {data.created || data.created_on}
                                </span>
                            </div>
                            <div className="col-auto d-flex flex-column text-end">
                                <span className="e-text-dark-heather e-primary-font-inter e-font-14-res e-font-14-res-lg e-font-16 e-font-weight-400 line-height-22px">
                                    {props.type === 1 ? "Next SIP date" : props.type === 3 ? "Executed date" : "Cancelled date"}
                                </span>
                                <span className="e-text-charleston-green e-primary-font-inter e-font-14-res e-font-14-res-lg  e-font-16 e-font-weight-600 line-height-22px">
                                    {props.type === 1 ? data.next_sip_date : props.type === 3 ? data.executed_date : data.cancelled}
                                </span>
                            </div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between">
                            <div className="col-auto d-flex flex-column">
                                <span className="e-text-dark-heather e-primary-font-inter e-font-14-res e-font-14-res-lg  e-font-16 e-font-weight-400 line-height-22px">
                                    SIP amount
                                </span>
                                <span className={`e-text-charleston-green e-primary-font-inter e-font-14-res  e-font-14-res-lg  e-font-16 e-font-weight-600 line-height-22px`}>
                                    {data.amount_text}
                                </span>
                            </div>

                            <div className="col-auto d-flex flex-column text-end">
                                <span className="e-text-dark-heather e-primary-font-inter e-font-14-res e-font-14-res-lg e-font-16 e-font-weight-400 line-height-22px">
                                    {
                                        data.type === "Basket" && props.type === 1 ? "SIPs Completed" : "Status"
                                    }
                                </span>
                                <span className={` ${props.type === 3 ? "e-text-manhattan-red" : props.type === 3 && data.status === "Failed" ? "e-text-manhattan-red" : props.type === 3 && data.status === "Success" ? "e-text-bottle-green" : data.type === "Basket" && props.type === 1 ? "e-text-charleston-green" : "e-text-bottle-green"}  e-primary-font-inter e-font-14-res e-font-14-res-lg  e-font-16 e-font-weight-600 line-height-22px`}>
                                    {data.type === "Basket" && props.type === 1 ? data.completed_installments + "/12" : props.type == 3 ? data.cancel_status : props.type == 2 ? data.status : "Active"}
                                </span>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={`${styles.e_sip_card_wrapper} ${props.selectedSIP?.sip_id === data.sip_id ? "e-border-1px-egyptian-blue" : "border-transparent"}  ${props.type === 2 ? "pe-none" : ""} transition cursor-pointer e-bg-cultured e-border-radius-16  h-100 p-3`}
                        onClick={props.onClickCard}>
                        <div className="d-flex gap-3 align-items-center">
                            <img src={data.icon}
                                className="w-40px width-24px-res h-40 h-auto-res object-fit-contain e-bg-white p-1 e-border-radius-8"
                                draggable="false"
                                alt="fund" />
                            <h2 className="flex-fill e-ellipse e-text-onyx e-primary-font-inter e-font-12-res e-font-14-res-lg e-font-16 e-font-weight-400 line-height-20px mb-0">
                                {data.name}
                            </h2>
                            <span className="ms-auto e-text-charleston-green e-primary-font-inter e-font-12-res e-font-16 e-font-weight-600 line-height-20px">
                                {`₹${_formatAmount(data.amount, 0)}`}
                            </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-start ms-5 mt-3">
                            <span className="e-text-html-css-gray e-primary-font-inter e-font-10-res e-font-12 e-font-weight-500 line-height-20px px-sm-2 px-1 e-border-radius-18 e-bg-white-marble">
                                {data.type}
                            </span>
                            {
                                props.type === 1 ?
                                    <span className={`e-border-1px-egyptian-blue  e-text-charleston-green e-bg-digital-lavender px-2 py-1 e-border-radius-4 e-font-10-res e-font-12 e-primary-font-inter e-font-weight-500 ms-2 ms-lg-0`} >
                                        Next SIP on : {data.next_sip_date}
                                    </span>
                                    :
                                    props.type === 3 ?
                                        <span className={`e-text-bottle-green e-font-10-res e-font-12 e-primary-font-inter e-font-weight-500 ms-2 ms-lg-0`} >
                                            Executed On: {data.executed_date}
                                        </span>
                                        :
                                        <>
                                            {
                                                data.cancel_status === "Cancelled" ?
                                                    <span className={`e-text-manhattan-red e-font-10-res e-font-12 e-primary-font-inter e-font-weight-500 ms-2 ms-lg-0`} >
                                                        Cancelled On  : {data.cancelled}
                                                    </span>
                                                    :
                                                    <span className={`e-border-1px-manhattan-red  e-text-manhattan-red e-bg-very-light-pink px-2 py-1 e-border-radius-4 e-font-10-res e-font-12 e-primary-font-inter e-font-weight-500 ms-2 ms-lg-0`} >
                                                        Cancellation in progress
                                                    </span>
                                            }
                                        </>

                            }

                        </div>
                    </div>
            }
        </>
    )
}

export default ActiveSIPCard;